// eslint-disable-next-line import/no-extraneous-dependencies
import { createGlobalStyle, css } from 'styled-components';
import * as globals from '@celebration/design-tokens/dist/ts/globals';
import * as light from '@celebration/design-tokens/dist/ts/a1/light';
import { convertToCSSVariables } from './utils/convert-to-css-variables';
export const transitionalButton = css `
  transition-duration: var(--velocity-medium);
  transition-property: background-color border-color;
  transition-timing-function: cubic-bezier(var(--vibe-soft));
`;
export const buttonBase = css `
  ${transitionalButton}
  cursor: pointer;
  border-radius: var(--border-radius-default);
  &:hover {
    border-color: var(--color-action-hover);
    background-color: var(--color-action-hover);
  }
  &:focus {
    border-color: var(--color-action-hover);
    background-color: var(--color-action-hover);
    outline-offset: 2px;
    outline: 2px solid var(--color-contrast-focused);
  }
  &:disabled {
    pointer-events: none;
    color: var(--color-neutral-300) !important;
    border-color: var(--color-neutral-200) !important;
    background-color: var(--color-neutral-200) !important;
  }
`;
export const primaryButton = css `
  ${transitionalButton}
  border: 2px solid;
  border-color: var(--color-action-default);
  background-color: var(--color-action-default);
  ${buttonBase}
`;
export const secundaryButton = css `
  ${transitionalButton}
  border: 2px solid;
  border-color: var(--color-neutral-600);
  background-color: var(--color-contrast-white);
  ${buttonBase}
`;
const GlobalStyle = createGlobalStyle `
  @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;600&display=swap');
  :root {
    --env-label-height: 25px;
    --menu-v1-width: 60px;
    --main-menu-size: 48px;
    --main-menu-padding: 20px;

    ${convertToCSSVariables(globals)}
    ${convertToCSSVariables(light)}
  }

  * {
    font-family: 'IBM Plex Sans', sans-serif;
  }

  .root-app_content, #root-app_side_content {
    * {
      color: var(--color-neutral-500);

      a {
        text-decoration: none;
      }
    }
  }

  input[type='radio'] {
    margin: 0;
    width: 16px;
    height: 16px;
    appearance: none;
    position: relative;

    &::before {
      content: " ";
      width: 12px;
      height: 12px;
      display: block;
      position: absolute;
      border: 2px solid var(--color-neutral-300);
      background-color: var(--color-neutral-100);
      border-radius: var(--border-radius-circular);
    }

    :checked {
      &::before {
        border: 2px solid var(--color-action-default);
        background-color: var(--color-action-default);
      }
      &::after {
        content: " ";
        top: 4px;
        left: 4px;
        width: 8px;
        height: 8px;
        position: absolute;
        border-radius: var(--border-radius-circular);
        background-color: var(--color-contrast-black);
      }
    }
  }

  body {
    margin: 0;
    padding: 0;
    overflow: hidden;

    #root-app_iframe {
      border: 0;
      margin: 0;
      padding: 0;
      width: 100%;
      height: 100%;
      display: block;
      min-height: 100%;
      background-color: var(--color-neutral-background);
    }
    #root-app_side_content {
      display: flex;
      flex-direction: row-reverse;
    }
  }
`;
export default GlobalStyle;
//# sourceMappingURL=global.style.js.map